// Accordion Components
export const Accordion = (() => {
	const selectors = {
		root: ".accordion",
		trigger: ".accordion__btn",
		panel: ".accordion__panel",
		content: ".accordion__content",
	};

	const togglePanel = (trigger, accordion, multiOpen = false) => {
		const contentId = trigger.getAttribute("aria-controls");
		const content = accordion.querySelector(`#${contentId}`);
		const panel = trigger.closest(selectors.panel);
		const isActive = panel.classList.contains("is-active");

		// Fermer les autres panneaux si multiOpen = false
		if (!multiOpen) {
			accordion.querySelectorAll(selectors.panel).forEach((p) => {
				p.classList.remove("is-active");
				p.querySelector(selectors.trigger).setAttribute("aria-expanded", "false");
				const cId = p.querySelector(selectors.trigger).getAttribute("aria-controls");
				accordion.querySelector(`#${cId}`).setAttribute("aria-hidden", "true");
			});
		}

		// Toggle du panneau cliqué
		if (!isActive) {
			panel.classList.add("is-active");
			trigger.setAttribute("aria-expanded", "true");
			content.setAttribute("aria-hidden", "false");
		} else {
			panel.classList.remove("is-active");
			trigger.setAttribute("aria-expanded", "false");
			content.setAttribute("aria-hidden", "true");
		}
	};

	const bindEvents = (accordion, multiOpen) => {
		accordion.querySelectorAll(selectors.trigger).forEach((trigger) => {
			trigger.addEventListener("click", () => togglePanel(trigger, accordion, multiOpen));
		});
	};

	const init = ({ multiOpen = false } = {}) => {
		document.querySelectorAll(selectors.root).forEach((accordion) => {
			bindEvents(accordion, multiOpen);
		});
	};

	return { init };
})();
